import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface FacturaEmpresaData {
  fecha: string;
  importeTotal: number;
  letra: string;
  numero: string;
  perifacturado: string;
  estado?: 'disponible' | 'en_gestion';
}

@Component({
  selector: 'app-factura-item-empresa',
  templateUrl: './factura-item.component.html',
  styleUrls: ['./factura-item.component.css']
})
export class FacturaItemEmpresaComponent {
  @Input() factura: FacturaEmpresaData;
  @Input() esDescargable: boolean = true;
  @Output() descargarPDF = new EventEmitter<FacturaEmpresaData>();

  constructor() { }

  onDescargarPDF() {
    if (this.esDescargable) {
      this.descargarPDF.emit(this.factura);
    }
  }

  getMonth(fecha: string): string {
    const formatofecha = fecha.split('/');
    const fechafinal = formatofecha[1] + '/' + formatofecha[0] + '/' + formatofecha[2];
    return new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(new Date(fechafinal));
  }

  getYear(fecha: string): string {
    const formatofecha = fecha.split('/');
    return formatofecha[2];
  }

  formatearMonto(monto: number): string {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2
    }).format(monto);
  }
}